import { BaseColumnFormatter } from "./BaseColumnFormatter";

export class JsonFormatter extends BaseColumnFormatter
{
    constructor(width?: string)
    {
        super();
        if (width)
            this.width = width;
    }
    override format(value: any): any
    {
        try
        {
            if (value)
                return JSON.stringify(value, undefined, 4);
        } catch (e)
        {
        }
        return value;
    }
}